import { Box } from '@mui/material'
import React from 'react'
import WidgetArea from './WidgetArea'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { WidgetAreasConfiguration } from '../types'
import {
  DASHBOARD_EDITOR_BATTERY_WIDGET_ID,
  DASHBOARD_EDITOR_DYNAMIC_POWER_PRICE_WIDGET_ID,
  DASHBOARD_EDITOR_WALLBOX_WIDGET_ID,
  DASHBOARD_EDITOR_WEATHER_FORECAST_WIDGET_ID,
} from 'src/Libs/qa/ids'

const WIDGETS_AMOUNT = 4

interface WidgetsProps {
  widgetAreasConfiguration: WidgetAreasConfiguration
  setWidgetAreasConfiguration: (areasConfiguration: WidgetAreasConfiguration) => void
  isDynamicPowerPriceEnabled: boolean
}

/**
 * Widgets component for the dashboard editor widget area
 */
const Widgets: React.FC<WidgetsProps> = ({ widgetAreasConfiguration, setWidgetAreasConfiguration, isDynamicPowerPriceEnabled }) => {
  const { t } = useCustomTranslation()
  const availableWidgetsAmount = WIDGETS_AMOUNT - (isDynamicPowerPriceEnabled ? 0 : 1)
  const hiddenWidgetsAmount = Object.values(widgetAreasConfiguration).filter(area => area.hidden).length
  const isLastDisplayedWidget = hiddenWidgetsAmount === availableWidgetsAmount - 1

  return (
    <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: '1fr 1fr', width: '100%' }}>
      <WidgetArea
        name={t('dashboard.editor.battery')}
        hidden={widgetAreasConfiguration.battery.hidden}
        setHidden={value => {
          if (value === true && isLastDisplayedWidget) return
          setWidgetAreasConfiguration({ ...widgetAreasConfiguration, battery: { hidden: value } })
        }}
        disabled={false}
        dataQa={DASHBOARD_EDITOR_BATTERY_WIDGET_ID}
      />
      <WidgetArea
        name={t('dashboard.editor.garage')}
        hidden={widgetAreasConfiguration.garage.hidden}
        setHidden={value => {
          if (value === true && isLastDisplayedWidget) return
          setWidgetAreasConfiguration({ ...widgetAreasConfiguration, garage: { hidden: value } })
        }}
        disabled={false}
        dataQa={DASHBOARD_EDITOR_WALLBOX_WIDGET_ID}
      />
      {isDynamicPowerPriceEnabled && (
        <WidgetArea
          name={t('dashboard.editor.price-history')}
          hidden={widgetAreasConfiguration.priceHistory.hidden}
          setHidden={value => {
            if (value === true && isLastDisplayedWidget) return
            setWidgetAreasConfiguration({ ...widgetAreasConfiguration, priceHistory: { hidden: value } })
          }}
          disabled={!isDynamicPowerPriceEnabled}
          dataQa={DASHBOARD_EDITOR_DYNAMIC_POWER_PRICE_WIDGET_ID}
        />
      )}
      <WidgetArea
        name={t('dashboard.editor.pv-forecast')}
        hidden={widgetAreasConfiguration.weatherForecast.hidden}
        setHidden={value => {
          if (value === true && isLastDisplayedWidget) return
          setWidgetAreasConfiguration({ ...widgetAreasConfiguration, weatherForecast: { hidden: value } })
        }}
        disabled={false}
        dataQa={DASHBOARD_EDITOR_WEATHER_FORECAST_WIDGET_ID}
      />
    </Box>
  )
}

export default Widgets
